(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["available-offers"] && !Shopify.designMode) return;
  try {
    (function() {
    /* Runs on page load and again whenever the theme editor re-draws a section:
       the editor swaps the markup in fresh, and a swiper built only on
       DOMContentLoaded is gone after the first edit (Soban, CAI deck slide 76). */
    function initOfferCards(root) {
      if (typeof Swiper === 'undefined') return;
      root.querySelectorAll('.offer-cards-swiper').forEach(function(swiperEl) {
        if (swiperEl.swiper) return;
        const blockId = swiperEl.dataset.blockId;
        new Swiper(swiperEl, {
          slidesPerView: 'auto',
          spaceBetween: 8,
          mousewheel: {
            forceToAxis: true,
            sensitivity: 0.3,
            releaseOnEdges: true,
            thresholdDelta: 20,
            thresholdTime: 100
          },
          navigation: {
            nextEl: `#OfferCardsNext-${blockId}`,
            prevEl: `#OfferCardsPrev-${blockId}`,
          },
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { initOfferCards(document); });
    } else {
      initOfferCards(document);
    }
    document.addEventListener('shopify:section:load', function(event) { initOfferCards(event.target || document); });
    document.addEventListener('shopify:block:select', function(event) { initOfferCards(event.target.closest('.shopify-section') || document); });
  })();
  } catch(e) { console.error(e); }
})();

})();
